import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Max delivery days'),"outlined":"","hide-details":"auto","type":"number"},model:{value:(_vm.maxDeliveryDays),callback:function ($$v) {_vm.maxDeliveryDays=_vm._n($$v)},expression:"maxDeliveryDays"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }